import {
  UPDATE_CANCEL_EMAIL_PERMISSION_REQUEST,
  UPDATE_CANCEL_EMAIL_PERMISSION_SUCCESS,
  UPDATE_CANCEL_EMAIL_PERMISSION_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CANCEL_EMAIL_PERMISSION_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_CANCEL_EMAIL_PERMISSION_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case UPDATE_CANCEL_EMAIL_PERMISSION_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

